var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "mb-1", attrs: { cols: "2" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-1", attrs: { cols: "2" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-1", attrs: { cols: "2" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-1", attrs: { cols: "2" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-1", attrs: { cols: "2" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-skeleton", {
            attrs: { animation: "fade", width: "100%", height: "12rem" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }